// Function to get an item from localStorage by ID
export function getLocalItemById(id) {
  try {
    const item = localStorage.getItem(id);

    return item ? JSON.parse(item) : null;
  } catch (_) {
    return null;
  }
}

// Function to set an item in localStorage by ID
export function setLocalItemById(id, value) {
  // Writes can throw when storage is unavailable (Safari private mode,
  // quota exceeded, disabled). Swallow so a persistence failure never
  // surfaces as an uncaught error from the effect that called us.
  try {
    localStorage.setItem(id, JSON.stringify(value));
  } catch (_) {
    // no-op: preference persistence is best-effort
  }
}
